<!-- система нотификаций -->
<template>
	<div class="w5-notificator-wrapper">
		<!-- кнопка закрытия всех уведомления -->
		<font-awesome-icon v-if="itemsCount > 1"
			@click.stop="removeAll"
			icon="times-circle"
			class="w5-notification-close-all-button"
		/>

		<transition-group name="w5-notificator">
			<!-- сообщение о тех кто смотрит в конкретный тикет  -->
			<div v-if="ticketView"
				key="ticketView"
				class="w5-notification cursor-pointer-default"
				:class="ticketView.class ? ticketView.class : false">
					<button id="notif-close-button" @click.stop="closeSpecialNotification('view')" class="close" :title="'main/close' | ftc">×</button>
					<strong>{{ ticketView.title | ftc }}</strong>
					<p style="padding: 0; margin: 0;" v-withSafeTags="ticketView.message"></p>
			</div>

			<!-- сообщение о тех кто пишет в конкретный тикет  -->
			<div v-if="ticketPost"
				key="ticketPost"
				class="w5-notification cursor-pointer-default ticket-post"
				:class="ticketPost.class ? ticketPost.class : false">
					<button id="notif-close-button" @click.stop="closeSpecialNotification('post')" class="close" :title="'main/close' | ftc">×</button>
					<strong>{{ ticketPost.title | ftc }}</strong>
					<p style="padding: 0; margin: 0;" v-withSafeTags="ticketPost.message"></p>
			</div>

			<!-- остальные сообщения -->
			<div v-for="(notification, idx) in items"
				:key="notification.key"
				class="w5-notification"
				:style="notification.id === 'success-message' ? 'cursor: default' : false"
				:class="notification.class ? notification.class : false"
				@click="goTo(notification, $event)">
					<button id="notif-close-button" @click.stop="remove(notification)" class="close" :title="'main/close' | ftc">×</button>
					<strong>{{ notification.title | ftc }}</strong>
					<p style="padding: 0; margin: 0;">{{ notification.message | ftc }}</p>
					<!-- переключатель звука в первом сообщении -->
					<template v-if="idx === 0 && notification.id !== 'success-message'">
						<font-awesome-icon id="notif-volume-button"
							:icon="whatVolume ? 'volume-up' : 'volume-mute'"
							class="w5-notification-volume-button pull-right"
							@click.stop="setVolume"
						/>
						<span class="clearfix"></span>
					</template>
			</div>
		</transition-group>
		<audio src="/static/snd/notif.mp3" ref="audioNotif_00" />
		<audio src="/static/snd/notif01.mp3" ref="audioNotif_01" />
		<audio src="/static/snd/notif02.mp3" ref="audioNotif_02" />
		<audio src="/static/snd/notif03.mp3" ref="audioNotif_03" />
		<audio src="/static/snd/notif04.mp3" ref="audioNotif_04" />
		<audio src="/static/snd/notif05.mp3" ref="audioNotif_05" />
	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import { EventBus } from '@/bus.js'
import Helper from '@/helper/helper.js'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'Notificator',
	//=========================================================================
	// неизменяемые свойства
	//=========================================================================
	props: {
		timeout: {
			type: Number,
			default: 60000
		}
	},
	//=========================================================================
	// вычисляемый свойства
	//=========================================================================
	computed: {
		itemsCount() {
			let count = this.items && this.items.length ? this.items.length : 0
			if (this.ticketView) count++
			if (this.ticketPost) count++

			return count
		}
	},
	//=========================================================================
	// изменяемые свойства
	//=========================================================================
	data () {
		return {
			// список объектов сообщений-нотификаций
			items: [],
			// сообщение-нотификация со списком кто смотрит в тикет
			ticketView: false,
			// сообщение-нотификация со списком кто пишет в тикет
			ticketPost: false,
			// таймеры специальных сообщений
			specialTimers: {
				'view': null,
				'post': null
			},
			// ссылка на элемент "audio"
			audio: null,
			canPlay: false,
			// какой трек играть
			trackNo: 0,

			// ссылка на значение опции - по умолчанию звук включен
			whatVolume: true
		}
	},
	//=========================================================================
	// обработчик: компонент примонтирован в DOM
	//=========================================================================
	mounted() {
		// первоначальное значение
		this.whatVolume = Helper.normalizeBooleanValue(this.$store.state.userServerOptions.play_audio_on_notification)
		// если значения нет - это true
		if (!('play_audio_on_notification' in this.$store.state.userServerOptions))
			this.whatVolume = true

		// подписка на событий
		EventBus.$on('w5-notificator-add-special', this.addSpecialNotificationHandler)
		EventBus.$on('w5-notificator-del-special', this.delSpecialNotificationHandler)
		EventBus.$on('w5-notificator-add', this.addNotificationHandler)
		EventBus.$on('w5-notificator-remove-all', this.removeAllNotificationHandler)
		EventBus.$on('w5-user-options-on-server', this.optionHandler)

		// получим элемент "audio"
		let _name = 'audioNotif_'
		if (['00', '01', '02', '03', '04', '05'].indexOf(this.$store.state.userServerOptions.audio_track_on_notification) > -1)
		{
			this.trackNo = parseInt(this.$store.state.userServerOptions.audio_track_on_notification, 10)
			_name += this.$store.state.userServerOptions.audio_track_on_notification
		}
		else
		{
			this.trackNo = 0
			_name += '00'
		}

		this.audio = this.$refs[_name]
		if (this.audio) this.audio.addEventListener('canplay', this.audioCanPlay)
	},
	//=========================================================================
	// обработчик: перед уничтожением компонента
	//=========================================================================
	beforeDestroy() {
		// отписка от событий
		EventBus.$off('w5-notificator-add-special', this.addSpecialNotificationHandler)
		EventBus.$off('w5-notificator-del-special', this.delSpecialNotificationHandler)
		EventBus.$off('w5-notificator-add', this.addNotificationHandler)
		EventBus.$off('w5-notificator-remove-all', this.removeAllNotificationHandler)
		EventBus.$off('w5-user-options-on-server', this.optionHandler)

		if (this.audio) this.audio.removeEventListener('canplay', this.audioCanPlay)
	},
	//=========================================================================
	// функции компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// удаляет заданное сообщение-нотификацию
		//---------------------------------------------------------------------
		remove(item) {
			let i = this.items.indexOf(item)
			if (i >= 0) this.items.splice(i, 1)
		},
		//---------------------------------------------------------------------
		// удаляет все сообщения-нотификации
		//---------------------------------------------------------------------
		removeAll() {
			this.ticketView = false
			this.ticketPost = false
			this.items = []
		},
		//---------------------------------------------------------------------
		// переход к итему сообщения-нотификации
		//---------------------------------------------------------------------
		goTo(item, e) {
			// если не задано сообщение
			if (!item) return
			// если это кликнули по кнопке закрытия
			if (e.target.id === 'notif-close-button') return

			// если тип задан "nourl" - ничего не делаем
			if (item['type'] === 'nourl') return

			// готовим URL для редиректа
			let _url = '/' + item['type'] + '/view/' + item['id']
			if (item['type'] === 'ticket') this.$store.commit('needUpperTab', item['id'])
			// делаем редирект
			this.$router.push(_url)
		},
		//---------------------------------------------------------------------
		// закрывает специальное сообщение-нотификацию
		//---------------------------------------------------------------------
		closeSpecialNotification(what) {
			if (what === 'view') this.ticketView = false
			if (what === 'post') this.ticketPost = false
		},
		//---------------------------------------------------------------------
		// изменение опции пользователя по проигрыванию звука при нотификации
		//---------------------------------------------------------------------
		setVolume() {
			this.$store.commit('toggleAudioNitificationOption')
		},
		//---------------------------------------------------------------------
		// изменение опции пользователя по проигрыванию звука при нотификации
		// выбрали номер трека
		//---------------------------------------------------------------------
		setTrack(value) {
			// если тот же
			if (this.trackNo === value) return

			// сформируем наименование трека
			let _name = 'audioNotif_0' + String(value)
			// если такой трек есть
			if (this.$refs[_name])
			{
				// запоминаем номер трека локально
				this.trackNo = value
				// сброс обработчиков
				if (this.audio) this.audio.removeEventListener('canplay', this.audioCanPlay)
				// получим элемент "audio" заново
				this.audio = this.$refs[_name]
				// новый обработчик
				this.audio.addEventListener('canplay', this.audioCanPlay)
				// проиграем звук
				this.audio.currentTime = 0
				try {
					this.audio.play().catch(() => {})
				}
				catch (e) {}
				// сохраним его на сервере
				this.$store.commit('setAudioTrackNitificationOption', value)
			}
		},
		//---------------------------------------------------------------------
		// событие: добавление сообщения-нотификации в систему
		//---------------------------------------------------------------------
		addNotificationHandler(data) {
			// проверка входных данных
			if (!data ||
				!data.title || data.title === '' ||
				!data.message || data.message === '' ||
				!data.type || !data.id || !data.class)
				return

			// формируем сообщение-нотификацию
			let item = {
				'title': data.title,
				'message': data.message,
				'class': data.class,
				'type': data.type,
				'id': data.id,
				'timeout': data.timeout,
				'key': `${Date.now()}-${Math.random()}`
			}

			// если в таблице уже есть такое сообщение
			let _exists = -1
			this.items.some((n, i) => {
				if (n['type'] === item['type'] && n['id'] === item['id'] && n['class'] === item['class'] && n['message'] === item['message'])
				{
					_exists = i
					return true
				}
			})
			// то удалим его
			if (_exists >= 0) this.items.splice(_exists, 1)

			// если количество сообщений больше 15
			if (this.items.length > 15)
			{
				// удалим самое первое сообщение
				this.items.splice(0, 1)
			}

			// если еще нет сообщений в базе - проиграем звук
			if (!this.items.length && this.canPlay && item.id !== 'success-message' && this.whatVolume)
			{
				this.audio.currentTime = 0
				try {
					this.audio.play().catch(() => {})
				}
				catch (e) {}
			}

			// если это сообщение об успехе - добавляем в начало
			if (item.id === 'success-message') this.items.unshift(item)
			// иначе - добавляем в нашу базу в конец
			else this.items.push(item)

			// заряжаем таймер на самоудаление
			setTimeout(() => this.remove(item), item.timeout ? item.timeout : this.timeout)
		},
		//---------------------------------------------------------------------
		// событие: добавление специального ("view" или "post") сообщения-нотификации в систему
		//---------------------------------------------------------------------
		addSpecialNotificationHandler(data) {
			// проверка входных данных
			if (!data ||
				!data.special || data.special === '' ||
				!data.title || data.title === '' ||
				!data.message || data.message === '' ||
				!data.type || !data.class)
				return

			// формируем сообщение-нотификацию
			let item = {
				'title': data.title,
				'message': data.message,
				'class': data.class,
				'type': data.type,
				'key': `${Date.now()}-${Math.random()}`
			}

			// запоминаем сообщение-нотификацию
			if (data.special === 'view') this.ticketView = item
			else if (data.special === 'post') this.ticketPost = item

			// если задан свой таймаут - получим его
			let _timeout = data.timeout && data.timeout > 0 ? data.timeout : this.timeout
			// если таймер уже заряжен - чистим его
			if (this.specialTimers[data.special]) clearTimeout(this.specialTimers[data.special])
			// заряжаем таймер на самоудаление
			this.specialTimers[data.special] = setTimeout(() => {
				this.specialTimers[data.special] = null
				this.closeSpecialNotification(data.special)
			}, _timeout)
		},
		//---------------------------------------------------------------------
		// событие: удаление специального сообщения-нотификации
		//---------------------------------------------------------------------
		delSpecialNotificationHandler(data) {
			this.closeSpecialNotification(data)
		},
		//---------------------------------------------------------------------
		// событие: удаление всех сообщений
		//---------------------------------------------------------------------
		removeAllNotificationHandler() {
			this.removeAll()
		},
		//---------------------------------------------------------------------
		// событие: можно проигрывать аудио
		//---------------------------------------------------------------------
		audioCanPlay() {
			this.canPlay = true
		},
		//---------------------------------------------------------------------
		// событие: изменились данные в Vuex об опциях пользователя
		//---------------------------------------------------------------------
		optionHandler() {
			// нас интересуют следующие опции
			// включен звук или нет
			this.whatVolume = Helper.normalizeBooleanValue(this.$store.state.userServerOptions.play_audio_on_notification)
			// если значения нет - это true
			if (!('play_audio_on_notification' in this.$store.state.userServerOptions))
				this.whatVolume = true
			// номер трека
			this.trackNo = parseInt(this.$store.state.userServerOptions.audio_track_on_notification, 10)
			if (isNaN(this.trackNo) || this.trackNo < 0 || this.trackNo > 5) this.trackNo = 0

			// название трека
			let _name = 'audioNotif_0' + this.trackNo
			if (this.$refs[_name])
			{
				// сброс обработчиков
				if (this.audio) this.audio.removeEventListener('canplay', this.audioCanPlay)
				// получим элемент "audio" заново
				this.audio = this.$refs[_name]
				// новый обработчик
				this.audio.addEventListener('canplay', this.audioCanPlay)
			}
		},
		//---------------------------------------------------------------------
		// враппер-функция
		//---------------------------------------------------------------------
		normalizeBooleanValue(value) {
			return Helper.normalizeBooleanValue(value)
		}

		//---------------------------------------------------------------------
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style scoped>
.w5-notificator-wrapper {
	position: fixed;
	top: 60px;
	right: 0;
	z-index: 10000;
	width: 300px;
	padding-left: 10px;
	padding-right: 10px;
}

.w5-notificator-wrapper .w5-notification {
	margin-bottom: 10px;
	transition: all .3s ease;
	border: 1px solid #454d5d;
	border-radius: 4px;
	display: block;
	padding: 10px;
	font-size: 90%;
	opacity: 0.8;
	cursor: pointer;
}

.w5-notificator-wrapper .w5-notification:hover {
	opacity: 1;
}

.w5-notification.info {
	color: #fff;
	background-color: #5bc0de;
	border-color: #5bc0de;
}

.w5-notification.success {
	color: #fff;
	background-color: #32b643;
	border-color: #32b643;
}

.w5-notification.warning {
	color: #fff;
	background-color: #ffb700;
	border-color: #ffb700;
}

.w5-notification.error {
	color: #fff;
	background-color: #e85600;
	border-color: #e85600;
}

.w5-notification.default {
	color: #000;
	background-color: #c0c0c0;
	border-color: #c0c0c0;
}

.w5-notification > .track-choice {
	float: left;
	font-weight: bold;
	padding: 5px;
	border-radius: 50%;
	color: #666;
	font-size: 10px;
	cursor: pointer;
	margin-right: 10px;
	transition: color 0.2s;
	line-height: 1;
}
.w5-notification > .track-choice:hover, .w5-notification > .track-choice.selected {
	color: white;
}

.w5-notificator-enter, .w5-notificator-leave-to {
	-webkit-transform: translate(100%);
	transform: translate(100%);
}

.w5-notification-volume-button {
	color: #000;
	opacity: 0.5;
	width: 16px;
}
.w5-notification-volume-button:hover, .w5-notification-volume-button:focus {
	color: #fff;
	opacity: 0.9;
}

.w5-notification-close-all-button {
	position: fixed;
	top: 40px;
	right: 16px;
	z-index: 10001;

	font-size: 16px;
	color: black;
	opacity: 0.5;
	cursor: pointer;
}
.w5-notification-close-all-button:hover, .w5-notification-close-all-button:focus {
	opacity: 0.9;
}

.ticket-post {
	background-color: #ffd1ef !important
}

</style>



// WEBPACK FOOTER //
// notificator.vue?54ce77b7